<template>
  <transition name="fade">
    <div v-if="show" class="modal-overlay" @click.self="emitClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Etiquetas de <span class="ellipsis" :title="contactName">{{ contactName }}</span></h3>
          <button class="close-button" @click="emitClose" aria-label="Cerrar">
            <ion-icon name="close-outline" />
          </button>
        </div>

        <div class="modal-body" :aria-busy="isLoading ? 'true' : 'false'">
          <!-- Loading -->
          <div v-if="isLoading" class="loading-list">
            <ion-icon name="reload-outline" class="spin"></ion-icon>
            <span>Cargando etiquetas…</span>
          </div>

          <!-- Lista -->
          <ul v-else class="tag-list">
            <li
              v-for="tag in tags"
              :key="tag.id"
              class="tag-item"
            >
              <div class="tag-info">
                <div class="tag-icon" :style="{ backgroundColor: tag.color }">
                  <ion-icon name="pricetag-outline"></ion-icon>
                </div>

                <div class="tag-texts">
                  <p class="tag-name">{{ tag.name }}</p>
                  <small class="tag-hint" :class="{ on: isAssigned(tag.id) }">
                    {{ isAssigned(tag.id) ? 'Asignada' : 'No asignada' }}
                  </small>
                </div>
              </div>

              <button
                class="chip-toggle"
                :class="{ active: isAssigned(tag.id) }"
                :disabled="isBusyId !== null"
                @click="toggle(tag)"
              >
                <ion-icon
                  v-if="isBusyId === tag.id"
                  key="spin"
                  class="chip-icon spin"
                  name="reload-outline"
                ></ion-icon>

                <ion-icon
                  v-else
                  :key="`state-${isAssigned(tag.id)}-${tag.id}`"
                  class="chip-icon"
                  :name="isAssigned(tag.id) ? 'remove-circle-outline' : 'add-circle-outline'"
                ></ion-icon>

                <span class="chip-label">
                  {{ isBusyId === tag.id ? 'Procesando…' : (isAssigned(tag.id) ? 'Quitar' : 'Asignar') }}
                </span>
              </button>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";

export default {
  name: "TagAssignRemoveModal",
  props: {
    show: { type: Boolean, default: false },
    contactId: { type: [Number, String], required: true },
    contactName: { type: String, default: '' },
    contactTags: { type: Array, default: () => [] },
  },
  data() {
    return {
      tags: [],
      isLoading: false,
      isBusyId: null,
      assignedIds: new Set(),
    };
  },
  watch: {
    show: {
      immediate: true,
      handler(v) {
        if (v) {
          this.assignedIds = new Set((this.contactTags || []).map(t => t.id));
          this.fetchTags();
        }
      },
    },
    contactTags: {
      immediate: true,
      handler(list) {
        this.assignedIds = new Set((list || []).map(t => t.id));
      },
    }
  },
  methods: {
    emitClose() { this.$emit("close"); },
    headers() {
      const token = localStorage.getItem("token");
      return { Authorization: `Bearer ${token}` };
    },
    async fetchTags() {
      this.isLoading = true;
      try {
        const { data } = await axios.get("/tags", { headers: this.headers() });
        this.tags = Array.isArray(data) ? data : [];
      } catch (e) {
        console.error("Error al obtener etiquetas:", e);
      } finally {
        this.isLoading = false;
      }
    },
    isAssigned(tagId) {
      return this.assignedIds.has(tagId);
    },
    async toggle(tag) {
      if (this.isBusyId) return;
      this.isBusyId = tag.id;
      try {
        if (this.isAssigned(tag.id)) {
          await axios.delete(`/tags/${tag.id}/contacts/${this.contactId}`, {
            headers: this.headers(),
          });
          this.assignedIds.delete(tag.id);
        } else {
          await axios.post(
            "/tags/assign",
            { contact_ids: [this.contactId], tag_ids: [tag.id] },
            { headers: this.headers() }
          );
          this.assignedIds = new Set([tag.id]);
        }

        const updated = this.tags.filter(t => this.assignedIds.has(t.id));
        this.$emit("changed", { contactId: this.contactId, tags: updated });
      } catch (e) {
        console.error("Error al alternar etiqueta:", e);
      } finally {
        this.isBusyId = null;
      }
    },
  },
};
</script>

<style scoped>
@keyframes modalFadeIn { 
  from {opacity:0; transform: translateY(-12px) scale(.98);} 
  to{opacity:1; transform: none;} 
}

.modal-overlay { 
  position: fixed; 
  inset: 0; 
  background: rgba(20,20,20,.65); 
  backdrop-filter: blur(4px); 
  display: grid; 
  place-items: center; 
  z-index: 2000; 
}

.modal-content { 
  background: #fff; 
  width: 480px; 
  max-height: 75vh; 
  padding: 20px 22px; 
  border-radius: 16px; 
  box-shadow: 0 8px 24px rgba(0,0,0,.18); 
  animation: modalFadeIn .28s ease both; 
  display: flex; 
  flex-direction: 
  column; gap: 18px; 
  overflow: hidden; 
  font-family: 'Poppins','Segoe UI',sans-serif; 
}

.modal-header { 
  display: flex; 
  align-items: center; 
  justify-content: space-between; 
  padding-bottom: 10px; 
  border-bottom: 2px solid #f0f0f0; 
}

.modal-header h3 { 
  margin: 0; 
  font-size: 18px; 
  font-weight: 600; 
  color: #0f172a; 
}

.modal-title {
  flex: 1;
  min-width: 0;               
  display: flex;
  align-items: center;
  gap: 6px;
}
.modal-title .ellipsis {
  max-width: 220px;          
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  color: #0f172a;
  font-weight: 600;
}

.close-button {
  background: none;
  border: 0;
  cursor: pointer;
  font-size: 22px;
  color: #888;
  transition: color .2s ease, transform .2s ease;
}

.close-button:hover { 
  color: #e11d48; 
  transform: scale(1.2);
}

.modal-body { 
  overflow-y: 
  auto; max-height: calc(75vh - 110px); 
  padding-right: 6px; 
  scrollbar-width: thin; 
  scrollbar-color: #cbd5e1 transparent; 
}

.modal-body::-webkit-scrollbar { 
  width: 6px;
}

.modal-body::-webkit-scrollbar-thumb { 
  background: #cbd5e1; 
  border-radius: 4px; 
}

.tag-list { 
  list-style: none; 
  margin: 0;
  padding: 0; 
  display: flex; 
  flex-direction: column; 
  gap: 10px; 
}

.tag-item { 
  display: flex; 
  align-items: center; 
  justify-content: space-between; 
  gap: 10px; 
  padding: 10px 12px; 
  border: 1px solid #e5e7eb; 
  background: #fafafa; 
  border-radius: 12px; 
  transition: background .2s ease, 
  border-color .2s ease; 
}

.tag-item:hover { 
  background: #f3f4f6; 
  border-color: #e2e8f0; 
}

.tag-info { 
  display: flex; 
  align-items: center; gap: 12px; 
}

.tag-icon { 
  width: 36px; 
  height: 36px; 
  border-radius: 50%; 
  display: grid; 
  place-items: center; 
  color: #fff;
  box-shadow: 0 2px 6px rgba(0,0,0,.15); 
}

.tag-texts { 
  display: flex; 
  flex-direction: column;
  align-items: flex-start;
}

.tag-name { 
  margin: 0; 
  font-weight: 600; 
  color: #0f172a; 
}

.tag-hint { 
  color: #64748b; 
  margin: 0;
}

.tag-hint.on { 
  color: #059669; 
}

.chip-toggle {
  display: inline-flex; align-items: center; gap: .45rem;
  height: 36px; padding: 0 .85rem; border-radius: 999px;
  border: 1px solid #e2e8f0; background: #ffffff; color: #0f172a;
  font: 600 .9rem/1 'Manrope', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  box-shadow: 0 1px 2px rgba(2,6,23,.04);
  transition: background .2s, border-color .2s, box-shadow .2s, color .2s, transform .04s;
}

.chip-toggle .chip-icon { 
  font-size: 1.05rem; 
  opacity: .85; 
}

.chip-toggle:hover { 
  background: #f8fafc; 
  border-color: #cbd5e1; 
  box-shadow: 0 2px 8px rgba(2,6,23,.06); 
}

.chip-toggle:active { 
  transform: translateY(1px); 
}

.chip-toggle.active { 
  background: #2563eb; 
  color: #fff; 
  border-color: #e2e8f0; 
  -shadow: 0 4px 14px rgba(37,99,235,.25); 
}

.chip-toggle.active .chip-icon { 
  opacity: 1; 
  color: #fff; 
}

@keyframes spin { 
  to { transform: rotate(360deg); } 
}

.spin { 
  display: inline-block; 
  animation: spin .9s linear infinite; 
}

.loading-list { 
  display: flex; 
  gap: 8px; 
  align-items: center; 
  justify-content: center; 
  color: #64748b; 
  padding: 16px; 
}

.chip-toggle:disabled {
  opacity: .6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
</style>
